import {REPORT_TYPE} from '../../../../models';

export const getRunButtonText = (reportType?: string) => {
  if (reportType === REPORT_TYPE.REPORT) {
    return 'Run Report';
  } else if (reportType === REPORT_TYPE.NOTEBOOK) {
    return 'Run Notebook';
  }
  return '';
}
